import React, { useEffect } from 'react';
import { observer, inject } from 'mobx-react';
import styles from './sizePanel.scss';
import classNames from 'classnames';
import { IVariantStore } from '../../../../types';
import TabNavigationHelper from '../../../../helpers/tabNavigationHelper';
import { SizeDimensions } from '../sizeDimensions/sizeDimensions';
import { SizeValues } from '../sizeValues/sizeValues';
import SizeTable from '../../../icons/sizeTable';
import * as helper from '../../../../helpers/html-helper';
import Triangle from '../../../icons/triangle';

export const SizePanel = inject('variantStore')(
    observer(({ variantStore }: IVariantStore) => {
        const tabNavigation = TabNavigationHelper.instance;
        const isMobile = variantStore?.mainStore.isMobileShop;

        function redirectToSizeTable() {
            if (variantStore?.sbiVariantSelection.sizeTableType == 'clothing')
                window.location.href = `${variantStore.mainStore.localization.generalL10n.clothingSizeTableUrl}`;
            if (variantStore?.sbiVariantSelection.sizeTableType == 'gloves')
                window.location.href = `${variantStore.mainStore.localization.generalL10n.glovesSizeTableUrl}`;
        }

        useEffect(() => {
            if (variantStore?.showSizeAccuracy) {
                // Setting marker position on fit_accuracy_scale
                const marker = document.getElementById('marker');
                const fit_accuracy_scales = document.getElementById('fit_accuracy_scales');

                if (marker && fit_accuracy_scales && 
                    (variantStore?.selectedBrickItem.selectedSize?.fittingAccuracy !== undefined)) {
                    const halfScaleWidth = fit_accuracy_scales.offsetWidth / 2;
                    const markerPosition = 
                        (halfScaleWidth * variantStore.selectedBrickItem.selectedSize.fittingAccuracy) / 0.5;
                    marker.style.marginLeft = halfScaleWidth + markerPosition + 'px';
                }
            }
        });

        return (
            <div data-testid='size_panel_wrapper' className={styles.size_panel_wrapper}>
                <div className={styles.size_content}>
                    {variantStore?.sbiVariantSelection.availableSizeTypes && (
                        <div className={styles.size_panel_content} ref={(el)=>tabNavigation.setGroupAtt(el)}>
                            {isMobile ? (
                                <label className={classNames(styles.choosen_size_label, 'notranslate')}>
                                    {variantStore.mainStore.localization.generalL10n.selection}:
                                    {' ' + variantStore?.selectedBrickItem.selectedSize?.label}
                                </label>
                            ) : null}
                            <SizeDimensions />
                            <SizeValues />
                            {/* <WWSKioskInfo /> not for now*/}
                            {!isMobile ? (
                                <label className={classNames(styles.choosen_size_label, 'notranslate')}>
                                    {variantStore.mainStore.localization.generalL10n.selection}:
                                    {' ' + variantStore?.selectedBrickItem.selectedSize?.label}
                                </label>
                            ) : null}
                            {variantStore.sbiVariantSelection.sizeTableType && (
                                <button
                                    data-testid='button_size_table'
                                    className={styles.size_table_button}
                                    onClick={redirectToSizeTable}
                                    ref={(el)=>tabNavigation.setFocusAtt(el)}
                                >
                                    <SizeTable />
                                    <span className={styles.size_table_text}>
                                        {helper.decodeHTML(variantStore.mainStore.localization.generalL10n.sizeTable)}
                                    </span>
                                </button>
                            )}
                            {variantStore.showSizeAccuracy && (
                                <div data-testid='fit_accuracy_wrapper' className={styles.fit_accuracy_wrapper}>
                                    <label>
                                        {helper.decodeHTML(
                                            variantStore.mainStore.localization.generalL10n.fittingAccuracy
                                        )}
                                    </label>
                                    <div className={styles.fit_accuracy_container}>
                                        <div className={classNames(styles.fit_accuracy_border, styles.border_left)} />
                                        <div id='fit_accuracy_scales' className={styles.fit_accuracy_scales}>
                                            <div className={styles.fit_accuracy_scale} />
                                            <div className={styles.fit_accuracy_scale} />
                                            <div className={styles.fit_accuracy_scale} />
                                        </div>
                                        <div id='marker' className={styles.marker}>
                                            <Triangle />
                                        </div>
                                        <div className={classNames(styles.fit_accuracy_border, styles.border_right)} />
                                    </div>
                                    <table className={styles.section_headlines}>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    {helper.decodeHTML(
                                                        variantStore.mainStore.localization.generalL10n.smallerSize
                                                    )}
                                                </td>
                                                <td>
                                                    {helper.decodeHTML(
                                                        variantStore.mainStore.localization.generalL10n.matchingSize
                                                    )}
                                                </td>
                                                <td>
                                                    {helper.decodeHTML(
                                                        variantStore.mainStore.localization.generalL10n.largerSize
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    })
);
